import React from "react";

function DueTodaySvgComponent(props: any) {
  return (
    <div>
      <svg
        id="today_black_24dp"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          id="Path_40078"
          data-name="Path 40078"
          d="M0,0H24V24H0Z"
          fill="none"
        />
        <path
          id="Path_40079"
          data-name="Path 40079"
          d="M19,3H18V1H16V3H8V1H6V3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,16H5V9H19ZM19,7H5V5H19ZM7,11h5v5H7Z"
          fill="#05a357"
        />
      </svg>
    </div>
  );
}

export default DueTodaySvgComponent;
